// Locale bundles for the wehunt-only page components that live in @wehunt/ui.
// Co-located with the components (not in the app) so the lib's own tests can
// resolve strings — dependency direction is app -> @wehunt/ui. The host app
// registers these into its i18next singleton; viltrapport never imports the
// components these back, so it pays nothing.
//
// Adding a namespace (CLUB-277 slices): create locales/<lng>/<ns>.json for every
// language, import them here, add to each uiLocale* bundle and to UI_NAMESPACES.
// The parity test (locales/__tests__/locale-shape.test.ts) and the app's
// registration pick them up automatically.
//
// Languages: en (source of truth), sv (full), fi/no/de/fr/da (draft — pending
// native review, CLUB-278/281/282 and the fr/da review tickets).
import commonEn from './en/common.json'
import teamsEn from './en/teams.json'
import huntsEn from './en/hunts.json'
import overviewEn from './en/overview.json'
import huntRailsEn from './en/huntRails.json'
import huntInvitationEn from './en/huntInvitation.json'
import mapEn from './en/map.json'
import planHuntEn from './en/planHunt.json'
import planHuntDrivesEn from './en/planHuntDrives.json'
import settingsEn from './en/settings.json'
import dogsEn from './en/dogs.json'
import devicesEn from './en/devices.json'
import outfitterEn from './en/outfitter.json'
import navEn from './en/nav.json'
import appEn from './en/app.json'
import replayEn from './en/replay.json'
import npsEn from './en/nps.json'
import statisticsEn from './en/statistics.json'

import commonSv from './sv/common.json'
import teamsSv from './sv/teams.json'
import huntsSv from './sv/hunts.json'
import overviewSv from './sv/overview.json'
import huntRailsSv from './sv/huntRails.json'
import huntInvitationSv from './sv/huntInvitation.json'
import mapSv from './sv/map.json'
import planHuntSv from './sv/planHunt.json'
import planHuntDrivesSv from './sv/planHuntDrives.json'
import settingsSv from './sv/settings.json'
import dogsSv from './sv/dogs.json'
import devicesSv from './sv/devices.json'
import outfitterSv from './sv/outfitter.json'
import navSv from './sv/nav.json'
import appSv from './sv/app.json'
import replaySv from './sv/replay.json'
import npsSv from './sv/nps.json'
import statisticsSv from './sv/statistics.json'

import commonFi from './fi/common.json'
import teamsFi from './fi/teams.json'
import huntsFi from './fi/hunts.json'
import overviewFi from './fi/overview.json'
import huntRailsFi from './fi/huntRails.json'
import huntInvitationFi from './fi/huntInvitation.json'
import mapFi from './fi/map.json'
import planHuntFi from './fi/planHunt.json'
import planHuntDrivesFi from './fi/planHuntDrives.json'
import settingsFi from './fi/settings.json'
import dogsFi from './fi/dogs.json'
import devicesFi from './fi/devices.json'
import outfitterFi from './fi/outfitter.json'
import navFi from './fi/nav.json'
import appFi from './fi/app.json'
import replayFi from './fi/replay.json'
import npsFi from './fi/nps.json'
import statisticsFi from './fi/statistics.json'

import commonNo from './no/common.json'
import teamsNo from './no/teams.json'
import huntsNo from './no/hunts.json'
import overviewNo from './no/overview.json'
import huntRailsNo from './no/huntRails.json'
import huntInvitationNo from './no/huntInvitation.json'
import mapNo from './no/map.json'
import planHuntNo from './no/planHunt.json'
import planHuntDrivesNo from './no/planHuntDrives.json'
import settingsNo from './no/settings.json'
import dogsNo from './no/dogs.json'
import devicesNo from './no/devices.json'
import outfitterNo from './no/outfitter.json'
import navNo from './no/nav.json'
import appNo from './no/app.json'
import replayNo from './no/replay.json'
import npsNo from './no/nps.json'
import statisticsNo from './no/statistics.json'

import commonDe from './de/common.json'
import teamsDe from './de/teams.json'
import huntsDe from './de/hunts.json'
import overviewDe from './de/overview.json'
import huntRailsDe from './de/huntRails.json'
import huntInvitationDe from './de/huntInvitation.json'
import mapDe from './de/map.json'
import planHuntDe from './de/planHunt.json'
import planHuntDrivesDe from './de/planHuntDrives.json'
import settingsDe from './de/settings.json'
import dogsDe from './de/dogs.json'
import devicesDe from './de/devices.json'
import outfitterDe from './de/outfitter.json'
import navDe from './de/nav.json'
import appDe from './de/app.json'
import replayDe from './de/replay.json'
import npsDe from './de/nps.json'
import statisticsDe from './de/statistics.json'

import commonDa from './da/common.json'
import teamsDa from './da/teams.json'
import huntsDa from './da/hunts.json'
import overviewDa from './da/overview.json'
import huntRailsDa from './da/huntRails.json'
import huntInvitationDa from './da/huntInvitation.json'
import mapDa from './da/map.json'
import planHuntDa from './da/planHunt.json'
import planHuntDrivesDa from './da/planHuntDrives.json'
import settingsDa from './da/settings.json'
import dogsDa from './da/dogs.json'
import devicesDa from './da/devices.json'
import outfitterDa from './da/outfitter.json'
import navDa from './da/nav.json'
import appDa from './da/app.json'
import replayDa from './da/replay.json'
import npsDa from './da/nps.json'
import statisticsDa from './da/statistics.json'

import commonFr from './fr/common.json'
import teamsFr from './fr/teams.json'
import huntsFr from './fr/hunts.json'
import overviewFr from './fr/overview.json'
import huntRailsFr from './fr/huntRails.json'
import huntInvitationFr from './fr/huntInvitation.json'
import mapFr from './fr/map.json'
import planHuntFr from './fr/planHunt.json'
import planHuntDrivesFr from './fr/planHuntDrives.json'
import settingsFr from './fr/settings.json'
import dogsFr from './fr/dogs.json'
import devicesFr from './fr/devices.json'
import outfitterFr from './fr/outfitter.json'
import navFr from './fr/nav.json'
import appFr from './fr/app.json'
import replayFr from './fr/replay.json'
import npsFr from './fr/nps.json'
import statisticsFr from './fr/statistics.json'

export const UI_NAMESPACES = [
  'common',
  'teams',
  'hunts',
  'overview',
  'huntRails',
  'huntInvitation',
  'map',
  'planHunt',
  'planHuntDrives',
  'settings',
  'dogs',
  'devices',
  'outfitter',
  'nav',
  'app',
  'replay',
  'nps',
  'statistics',
] as const
export type UiNamespace = (typeof UI_NAMESPACES)[number]

export const uiLocaleEn = {
  common: commonEn,
  teams: teamsEn,
  hunts: huntsEn,
  overview: overviewEn,
  huntRails: huntRailsEn,
  huntInvitation: huntInvitationEn,
  map: mapEn,
  planHunt: planHuntEn,
  planHuntDrives: planHuntDrivesEn,
  settings: settingsEn,
  dogs: dogsEn,
  devices: devicesEn,
  outfitter: outfitterEn,
  nav: navEn,
  app: appEn,
  replay: replayEn,
  nps: npsEn,
  statistics: statisticsEn,
} as const
export const uiLocaleSv = {
  common: commonSv,
  teams: teamsSv,
  hunts: huntsSv,
  overview: overviewSv,
  huntRails: huntRailsSv,
  huntInvitation: huntInvitationSv,
  map: mapSv,
  planHunt: planHuntSv,
  planHuntDrives: planHuntDrivesSv,
  settings: settingsSv,
  dogs: dogsSv,
  devices: devicesSv,
  outfitter: outfitterSv,
  nav: navSv,
  app: appSv,
  replay: replaySv,
  nps: npsSv,
  statistics: statisticsSv,
} as const
export const uiLocaleFi = {
  common: commonFi,
  teams: teamsFi,
  hunts: huntsFi,
  overview: overviewFi,
  huntRails: huntRailsFi,
  huntInvitation: huntInvitationFi,
  map: mapFi,
  planHunt: planHuntFi,
  planHuntDrives: planHuntDrivesFi,
  settings: settingsFi,
  dogs: dogsFi,
  devices: devicesFi,
  outfitter: outfitterFi,
  nav: navFi,
  app: appFi,
  replay: replayFi,
  nps: npsFi,
  statistics: statisticsFi,
} as const
export const uiLocaleNo = {
  common: commonNo,
  teams: teamsNo,
  hunts: huntsNo,
  overview: overviewNo,
  huntRails: huntRailsNo,
  huntInvitation: huntInvitationNo,
  map: mapNo,
  planHunt: planHuntNo,
  planHuntDrives: planHuntDrivesNo,
  settings: settingsNo,
  dogs: dogsNo,
  devices: devicesNo,
  outfitter: outfitterNo,
  nav: navNo,
  app: appNo,
  replay: replayNo,
  nps: npsNo,
  statistics: statisticsNo,
} as const
export const uiLocaleDe = {
  common: commonDe,
  teams: teamsDe,
  hunts: huntsDe,
  overview: overviewDe,
  huntRails: huntRailsDe,
  huntInvitation: huntInvitationDe,
  map: mapDe,
  planHunt: planHuntDe,
  planHuntDrives: planHuntDrivesDe,
  settings: settingsDe,
  dogs: dogsDe,
  devices: devicesDe,
  outfitter: outfitterDe,
  nav: navDe,
  app: appDe,
  replay: replayDe,
  nps: npsDe,
  statistics: statisticsDe,
} as const

export const uiLocaleFr = {
  common: commonFr,
  teams: teamsFr,
  hunts: huntsFr,
  overview: overviewFr,
  huntRails: huntRailsFr,
  huntInvitation: huntInvitationFr,
  map: mapFr,
  planHunt: planHuntFr,
  planHuntDrives: planHuntDrivesFr,
  settings: settingsFr,
  dogs: dogsFr,
  devices: devicesFr,
  outfitter: outfitterFr,
  nav: navFr,
  app: appFr,
  replay: replayFr,
  nps: npsFr,
  statistics: statisticsFr,
} as const

export const uiLocaleDa = {
  common: commonDa,
  teams: teamsDa,
  hunts: huntsDa,
  overview: overviewDa,
  huntRails: huntRailsDa,
  huntInvitation: huntInvitationDa,
  map: mapDa,
  planHunt: planHuntDa,
  planHuntDrives: planHuntDrivesDa,
  settings: settingsDa,
  dogs: dogsDa,
  devices: devicesDa,
  outfitter: outfitterDa,
  nav: navDa,
  app: appDa,
  replay: replayDa,
  nps: npsDa,
  statistics: statisticsDa,
} as const

/** Keyed by language code — the shape the host merges into its i18next singleton. */
export const uiLocales = {
  en: uiLocaleEn,
  sv: uiLocaleSv,
  fi: uiLocaleFi,
  no: uiLocaleNo,
  de: uiLocaleDe,
  fr: uiLocaleFr,
  da: uiLocaleDa,
} as const

export type UiLanguage = keyof typeof uiLocales
